"use client"; // Ensure this directive is present
import corporateImg1 from '../../assets/images/resources/industry-corporate-1.png'
import corporateImg2 from '../../assets/images/resources/industry-corporate-2.png'
import schoolsImg1 from '../../assets/images/resources/industry-schools-1.jpg'
import schoolsImg2 from '../../assets/images/resources/industry-schools-2.png'
import sportsImg1 from '../../assets/images/resources/industry-sports-1.png'
import sportsImg2 from '../../assets/images/resources/industry-sports-2.jpg'
import eventsImg1 from '../../assets/images/resources/industry-events-1.png'
import eventsImg2 from '../../assets/images/resources/industry-events-2.png'

import React from 'react';

// Data for industry solutions
const industryData = [
    {
        id: 1,
        stat: '500+',
        category: 'Companies',
        title: 'Corporate & Business Events',
        description: 'Professional promotional products that elevate your brand presence at corporate events, meetings, and client relationships. Executive gifts, branded apparel, and trade show materials.',
        focus: 'Executive Excellence',
        subTitle: 'Professional Impact',
        img: [
            corporateImg1,
            corporateImg2,
        ],
        link: '/contact',
        delay: '100ms',
    },
    {
        id: 2,
        stat: '100+',
        category: 'Schools',
        title: 'Schools & Educational Programs',
        description: 'Custom apparel and promotional items that build school spirit, support fundraising goals, and create lasting memories. Student apparel, spirit wear, and educational materials.',
        focus: 'Building Spirit',
        subTitle: 'Educational Excellence',
        img: [
            schoolsImg1,
            schoolsImg2,
        ],
        link: '/contact',
        delay: '200ms',
    },
    {
        id: 3,
        stat: '200+',
        category: 'Teams',
        title: 'Sports Teams & Recreation',
        description: 'High-quality uniforms and promotional items that unite teams and engage fans across all sports and recreation activities. Team uniforms, sports equipment, and fan merchandise.',
        focus: 'Team Unity',
        subTitle: 'Athletic Excellence',
        img: [
            sportsImg1,
            sportsImg2,
        ],
        link: '/contact',
        delay: '300ms',
    },
    {
        id: 4,
        stat: '1000+',
        category: 'Events',
        title: 'Trade Shows & Marketing',
        description: 'Eye-catching promotional materials and memorable giveaways that attract visitors and generate leads at any trade show or marketing event. Banners, giveaways, and branded merchandise.',
        focus: 'Marketing Impact',
        subTitle: 'Event Excellence',
        img: [
            eventsImg1,
            eventsImg2,
        ],
        link: '/contact',
        delay: '400ms',
    },
];

export default function ScheduleThree() {
    return (
        <section id="th-event" className="schedule-three">
            <div className="container">
                <div className="schedule-three__top">
                    <div className="section-title text-center">
                        <div className="section-title__tagline-box">
                            <span className="section-title__tagline">Solutions by Industry</span>
                        </div>
                         <h2 className="section-title__title">Trusted by businesses across every sector</h2>
                    </div>
                </div>
                 <div className="schedule-three__bottom">
                     {industryData.map((industry) => (
                        <div key={industry.id} className={`schedule-three__routine-details wow fadeInLeft`} data-wow-delay={industry.delay}>
                            <div className="schedule-three__routine-details-description">
                                 <h4 className="schedule-three__routine-details-description-title">
                                     {industry.title}
                                 </h4>
                                 <p className="schedule-three__routine-details-description-text">{industry.description}</p>
                             </div>
                            <div className="schedule-three__routine-details-img-box">
                                 {industry.img.map((image, index) => {
                                    // For Trade Shows & Marketing (id: 4), only show the first image
                                    if (industry.id === 4 && index > 0) {
                                        return null;
                                    }
                                    return (
                                        <div key={index} className="schedule-three__routine-details-img-single">
                                             <img src={image} alt={`${industry.title} ${index + 1}`} />
                                        </div>
                                    );
                                 })}
                            </div>
                        </div>
                     ))}
                 </div>
            </div>
        </section>
    );
} 